import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import colors from "assets/theme/base/colors";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";
import FollowButton from "pages/social/followbutton";
import VirtualList from "rc-virtual-list";
import { useEffect, useState, useContext } from "react";
import api from "services/api";
import { accountTypeOptions } from "utils/data";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { AccountContext } from "context/account";

const smartdate = require("smartdate");
smartdate.init();

const FollowList = ({ tab, datalist, ContainerHeight = 600 }) => {
  const [list, setList] = useState([]);
  const [chatVisible, setChatVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  const handleClickMore = (user) => {};

  useEffect(() => {
    setList(datalist);
  }, [datalist]);

  return (
    <List sx={{ width: "100%", bgcolor: "background.paper" }}>
      {chatVisible && (
        <DraggableDialog
          heading={`Chat with ${currentUser?.name}`}
          text={
            <SuiBox>
              <ChatRoom id={currentUser?.roomid} />
            </SuiBox>
          }
          visible={chatVisible}
          hideAction={true}
          handleClose={() => {
            setChatVisible(false);
          }}
        />
      )}
      <VirtualList
        data={list}
        height={ContainerHeight}
        itemHeight={90}
        itemKey="email"
        onScroll={undefined}
      >
        {(user, index) => {
          const fullName = user.name;
          const accountType = user.account_role;
          const accountRole = accountTypeOptions.find((x) => x.value == accountType);
          return (
            <SuiBox key={user.id} sx={{ px: 2, py: 0.5 }}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  borderBottom: index == list.length ? "none" : `${colors.light.main} solid 1px`,
                }}
                secondaryAction={
                  <SuiBox display="flex">
                    <SuiButton
                      sx={{ mr: 2 }}
                      variant="outlined"
                      color="dark"
                      size="small"
                      circular
                      onClick={async () => {
                        const { data } = await api.chatroom.addChatRoom({
                          userids: [user.id],
                        });
                        setCurrentUser({ ...user, roomid: data.id });
                        setChatVisible(true);
                      }}
                    >
                      Message
                    </SuiButton>
                    <FollowButton user={user} size={"small"} style="w-[150px]" />
                  </SuiBox>
                }
              >
                <ListItemAvatar>
                  <Avatar
                    alt={user.name}
                    src={user.metadata?.avatar}
                    sx={{ width: 52, height: 52, cursor: "pointer" }}
                    onClick={() =>
                      account?.id
                        ? navigate(`/wall/portfolio/${user.id}`)
                        : navigate(`/public/portfolio/${user.id}`)
                    }
                  />
                </ListItemAvatar>
                <SuiBox sx={{ py: 1, ml: 2 }}>
                  <SuiTypography
                    variant="h6"
                    lineHeight={1.2}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      account?.id
                        ? navigate(`/wall/portfolio/${user.id}`)
                        : navigate(`/public/portfolio/${user.id}`)
                    }
                  >
                    {fullName}
                  </SuiTypography>
                  <SuiTypography variant="body1" color="text" lineHeight={1.2}>
                    {accountRole?.label || "Designer"}
                  </SuiTypography>
                  <SuiTypography variant="body1" color="text" lineHeight={1.2}>
                    {user.follow_type === 1 && user.timestamp
                      ? "Followed " + smartdate.format(new Date(user.timestamp))
                      : "_"}
                  </SuiTypography>
                </SuiBox>
              </ListItem>
            </SuiBox>
          );
        }}
      </VirtualList>
    </List>
  );
};

export default FollowList;
